export default __webpack_public_path__ + "static/media/code.b4dabadd.png";